import { useCallback } from "react";
export const useCallOnKeyPress = (func, triggerKeys) => {
    const f = useCallback(({ key }) => {
        if (triggerKeys.includes(key))
            func();
    }, [func, triggerKeys.join("-")]);
    return f;
};
